// extracted by css-extract-rspack-plugin
export default {"TextCell":"interactive-item-title-module__TextCell__iGkzZ","Link":"interactive-item-title-module__Link__nF3Bg","is-disabled":"interactive-item-title-module__is-disabled__ysjaj"};